
import { defineComponent } from 'vue'
import BillingTemplatesNewForm from '@/components/billing-templates/forms/new-billing-template.vue'
import { useRoute } from 'vue-router'

export default defineComponent({
    name: 'view-billing-templates-new-billing-template',
    components: { BillingTemplatesNewForm },
    setup () {
        const route = useRoute()
        const organizationId = route.params.organizationId as string

        return {
            organizationId
        }
    }
})
